$(document).ready(function () {
    $(".select2").select2();
    $(".fs-32.select2")
        .select2()
        .data("select2")
        .$container.addClass("select2jobdivisionmobile");

    $("body").on(
        "change", "#filterjobbydivision",
        function (e) {
        let url = $(this).find(":selected").data("url");
        window.location.replace(url);
    });
    
    $("body").on(
        "change",
        "#filterjobbyproduct, #filterjobbyapplication, #filterjobbyprovince",
        function () {
            var filterjobbyproduct = $("#filterjobbyproduct").val();
            var filterjobbyapplication = $("#filterjobbyapplication").val();
            var filterjobbyprovince = $("#filterjobbyprovince").val();

            // Se tutti i filtri sono vuoti, mostra tutto
            if (
                filterjobbyproduct == "" &&
                filterjobbyapplication == "" &&
                filterjobbyprovince == ""
            ) {
                $(".boxJobToFilter").parent().fadeIn();
            } else {
                $(".boxJobToFilter").each(function () {
                    var matchesProduct =
                        filterjobbyproduct == "" ||
                        $(this).hasClass(
                            "thisJobProduct_" + filterjobbyproduct
                        );
                    var matchesApplication =
                        filterjobbyapplication == "" ||
                        $(this).hasClass(
                            "thisJobApplication_" + filterjobbyapplication
                        );
                    var matchesProvince =
                        filterjobbyprovince == "" ||
                        $(this).hasClass(
                            "thisJobProvince_" + filterjobbyprovince
                        );

                    // Mostra solo se tutte le condizioni dei filtri sono soddisfatte
                    if (
                        matchesProduct &&
                        matchesApplication &&
                        matchesProvince
                    ) {
                        $(this).parent().fadeIn();
                    } else {
                        $(this).parent().fadeOut();
                    }
                });
            }
        }
    );
});
